import { z } from "zod/v4";

export const tableSpecSchema = z.object({
	permissions: z.array(z.any()),
});

export type TableSpec = z.infer<typeof tableSpecSchema>;
